import { Component, Input, Output, EventEmitter} from '@angular/core'

@Component({
  selector: 'app-st-button-pdf',
  templateUrl: './st-button-pdf.component.html',
  styleUrls: ['./st-button-pdf.component.scss'],
  standalone: false
})
export class StButtonPdfComponent {

  @Input()
  idVal: string = 'buttonId';

  @Input()
  label = 'Export to PDF';

  @Output()
  onClick = new EventEmitter<Event>();
}
